<div id="container" class="slider-trigger-container" tidyMultiClick="10" delay="5000" (onMultiClick)="onMultiClick()">
  <label *ngIf="!loading" class="slider-trigger-label">{{label}}</label>
  <ion-spinner *ngIf="loading"></ion-spinner>
  <input class="slider-trigger-input" type="range"
   min="0" max="1"
   [(ngModel)]="value" step=".01"
   [disabled]="disabled"
   (change)="onChanged()"/>
</div>
